import React from 'react';
import { BaseAlert, BaseAlertProps } from '../BaseAlert';
import { colors } from '../../../settings';
import styled from 'styled-components';
import { IconInfo } from '@99designs/icons';

export const StyledInfoAlert = styled(BaseAlert)`
    background: ${colors.semantic.info};
    color: white;
`;

type InfoAlertProps = Omit<BaseAlertProps, 'icon'>;

export function InfoAlert({ children, ...rest }: InfoAlertProps) {
    return (
        <StyledInfoAlert icon={<IconInfo />} {...rest}>
            {children}
        </StyledInfoAlert>
    );
}
